import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import ProgressBars from '../../components/customLayout/progressBars';
import TournamentCaptureTab from './TournamentCaptureTab';
import TournamentSetTab from './TournamentSetTab';
import TournamentReportTab from './TournamentReportTab';
import TournamentPreviewTab from './TournamentPreviewTab';
import { useTournamentStore } from '../../store/tournamentStore';
import { useDialogStore } from '../../store/dialogStore';
import { Button } from '../../components/ui/button';
import { ChevronRightIcon, ChevronLeftIcon } from '@heroicons/react/24/outline';
import teeColor from '../../assets/images/teeColor.jpg';
import axiosInstance from '../../axiosConfig';
import { useGlobalStore } from '../../store/globalStore';
import { useClubStore } from '../../store/clubStore';
import { Player } from '../../types/types';
import { isSameMemberNumber } from '../../utils/utils';
import { useNavigate } from 'react-router-dom';

const TournamentPage: React.FC = () => {
  const isLoading = useGlobalStore((state) => state.isLoading);
  const activeTab = useTournamentStore((state) => state.activeTab);
  const myClub = useClubStore((state) => state.myClub);
  const setInformation = useTournamentStore((state) => state.setInformation);
  const tournamentInformation = useTournamentStore(
    (state) => state.information,
  );
  const navigate = useNavigate();
  const setActiveTab = useTournamentStore((state) => state.setActiveTab);
  const setCapitan = useTournamentStore((state) => state.setCapitan);
  const setMelder = useTournamentStore((state) => state.setMelder);
  const setSelectedErsatzspieler = useTournamentStore(
    (state) => state.setSelectedErsatzspieler,
  );

  const setSelectedEinzelersatzspieler = useTournamentStore(
    (state) => state.setSelectedEinzelersatzspieler,
  );

  const setSelectedPlayers = useTournamentStore(
    (state) => state.setSelectedPlayers,
  );

  const setSelectedEinzelspieler = useTournamentStore(
    (state) => state.setSelectedEinzelspieler,
  );

  const colorWarningMessage = useTournamentStore(
    (state) => state.colorWarningMessage,
  );
  const playerWarningMessage = useTournamentStore(
    (state) => state.playerWarningMessage,
  );

  const params = useParams();

  const activePlayers = useTournamentStore((state) => state.activePlayers);
  const setActivePlayers = useTournamentStore(
    (state) => state.setActivePlayers,
  );
  const setPlayers = useTournamentStore((state) => state.setPlayers);
  const setCompanions = useTournamentStore((state) => state.setCompanions);
  const genderLimitation = useTournamentStore(
    (state) => state.information.gender,
  );

  const setLoading = useGlobalStore((state) => state.setLoading);
  const nextTab = useTournamentStore((state) => state.nextTab);
  const prevTab = useTournamentStore((state) => state.prevTab);
  const isNextEnabled = useTournamentStore((state) => state.isNextEnabled);
  const isPrevEnabled = useTournamentStore((state) => state.isPrevEnabled);

  const tournamentStore = useTournamentStore((state) => state);

  const openDialog = useDialogStore((state) => state.openDialog);
  const closeDialog = useDialogStore((state) => state.closeDialog);

  const geTournament = async () => {
    const response = await axiosInstance.get(`/tournament/${params.id}`);
    const res = response.data;

    if (!response.data.activeRegisterPlayer) {
      openDialog(
        <div>
          <div className="text-3xl text-center py-4 ">⏰️ Es ist zu spät!</div>
          <div>
            Die Frist für die Registrierung von Spielern in diesem Turnier ist
            abgelaufen.
          </div>{' '}
        </div>,
        () => {},
        true,
      );
      navigate('/league?ref=tournament-is-late');
    }

    // res.gender = 'N';
    // res.requireTee = true;
    // console.log(res);

    setInformation(res);
  };

  const geTournamentData = async () => {
    const response = await axiosInstance.get(`/tournament/${params.id}/data`);
    const res = response.data;
    const players = res.players
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      .map((player: any) => ({
        ...player,
        hcp: player.handicap,
        pending: false,
        color: '',
      }))
      .sort((a: { rank: number }, b: { rank: number }) => a.rank - b.rank);
    setActivePlayers(players);

    setSelectedPlayers(
      players
        .filter((p: { rank: number }) => p.rank !== 99)
        .sort((x: { rank: number }, y: { rank: number }) => x.rank - y.rank),
    );

    setSelectedEinzelspieler(
      players
        .filter((p: { rank: number }) => p.rank !== 99)
        .sort(
          (x: { individualRank: number }, y: { individualRank: number }) =>
            x.individualRank - y.individualRank,
        ),
    );

    setSelectedErsatzspieler(
      players
        .filter((p: { rank: number }) => p.rank === 99)
        .sort(
          (x: { individualRank: number }, y: { individualRank: number }) =>
            x.individualRank - y.individualRank,
        ),
    );

    setSelectedEinzelersatzspieler(
      players.filter(
        (p: { individualRank: number }) => p.individualRank === 99,
      ),
    );

    setCompanions(
      Array.from(
        { length: 4 },
        (_, i) => res.meldung[`companion${i + 1}`] || '',
      ),
    );

    setCapitan(res.meldung.captain || '');
    setMelder(res.meldung.melder || '');
  };

  const gePlayers = async () => {
    const response = await axiosInstance.get(
      `/tournament/${params.id}/players`,
    );
    const res = response.data.map((player: Player) => ({
      ...player,
      color: player.teeColor,
    }));
    setPlayers(res);
  };

  const submitData = async () => {
    setLoading(true);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { players, activePlayers, activeTab, sortedErsatzspielers, ...data } =
      tournamentStore;

    data.selectedPlayers = data.selectedPlayers.filter(
      (p: Player | null): p is Player => p !== null,
    );

    data.selectedErsatzspieler = data.selectedErsatzspieler.filter(
      (p: Player | null): p is Player => p !== null,
    );

    try {
      const response = await axiosInstance.post(
        'tournament/registration',
        data,
      );
      setLoading(false);
      return response.data;
    } catch (error) {
      console.error('Error submitting data:', error);
      setLoading(false);
      throw error;
    }
  };

  const getALL = async () => {
    setLoading(true);
    await geTournament();
    await geTournamentData();
    await gePlayers();
    setLoading(false);
  };

  useEffect(() => {
    getALL();
  }, []);

  useEffect(() => {
    if (
      !tournamentInformation ||
      Object.keys(tournamentInformation).length === 0
    )
      return;

    const numPlayers = Number(tournamentInformation.numberOfPlayers) || 0;
    const numSubstitutes =
      Number(tournamentInformation.numberOfSubstitute) || 0;

    const generateIndices = (length: number) =>
      Array.from({ length }, (_, i) => i);

    useTournamentStore.setState({
      sortedPlayers: generateIndices(numPlayers),
      sortedErsatzspielers: generateIndices(numSubstitutes),
      sortedEinzelspieler: generateIndices(numPlayers),
      sortedEinzelersatzspieler: generateIndices(numSubstitutes),
    });
  }, [tournamentInformation]);

  const updateHcp = async (clubNumberCountry: string) => {
    setLoading(true);
    try {
      const playerData = activePlayers.map(
        ({ memberNumber, name, lastName, gender }) => ({
          persid: memberNumber,
          firstname: name,
          lastname: lastName,
          gender,
        }),
      );
      const response = await axiosInstance.post(
        `/tournament/${clubNumberCountry}/update-hcp`,
        { players: playerData },
      );
      if (response.data.status === 'OK') {
        if (response.data.data.players?.length > 0) {
          const updatedPlayers = activePlayers.map((player) => {
            const matchedPlayer = response.data.data.players.find(
              (p: { person_persid: string }) =>
                isSameMemberNumber(p.person_persid, player.memberNumber),
            );

            if (matchedPlayer) {
              const gender = matchedPlayer.person_gender_x;
              const isInvalidGender =
                (['MW', 'N'].includes(genderLimitation) &&
                  !['W', 'M', 'F'].includes(gender)) ||
                (['W', 'F'].includes(genderLimitation) &&
                  !['W', 'F'].includes(gender)) ||
                (genderLimitation === 'M' && gender !== 'M');

              if (isInvalidGender) {
                alert(
                  `Das Geschlecht von ${matchedPlayer.person_forename} ${matchedPlayer.person_surname} wurde zu ${gender} geändert und ist gemäß den Regeln dieses Turniers nicht spielberechtigt, da dieses Turnier auf ${genderLimitation} beschränkt ist.`,
                );
              }
              return {
                ...player,
                name: matchedPlayer.person_forename,
                lastName: matchedPlayer.person_surname,
                gender: matchedPlayer.person_gender_x,
                hcp: matchedPlayer.person_handicap_decimal,
                title: '',
                pending: false,
              };
            } else {
              return {
                ...player,
                pending: true,
              };
            }
          });
          setActivePlayers(updatedPlayers);
        }
      }
    } catch (error) {
      console.error('Error logging in:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleNextTab = async () => {
    const colorWarning = colorWarningMessage();

    if (activeTab === 'capture' && activePlayers.length !== 0) {
      await updateHcp(myClub?.club_number + '').then(() => {
        nextTab();
      });
    } else if (
      activeTab === 'set' &&
      tournamentInformation.requireTee &&
      colorWarning !== ''
    ) {
      openDialog(
        <div>
          <div className="text-xl font-medium mb-5">🚨️ Achtung: </div>
          <img src={teeColor} alt="tee" className="mx-auto" />
          {colorWarning}
        </div>,
        () => {},
        true,
      );
    } else if (activeTab === 'preview') {
      openDialog(
        <div>
          <div className="text-xl font-medium mb-5">⚠️ Achtung: </div>
          {playerWarningMessage()}
        </div>,
        () => {
          submitData().then(() => {
            nextTab();
            closeDialog();
          });
        },
      );
    } else {
      nextTab();
    }
  };

  const items = [
    {
      key: 'capture',
      title: 'ERFASSEN',
      description: 'Spieler eingeben',
      icon: '⛳',
    },
    {
      key: 'set',
      title: 'SETZEN',
      description: 'Reihenfolge festlegen',
      icon: '📋',
    },
    {
      key: 'preview',
      title: 'VORSCHAU',
      description: 'Vorschau der Turnierdaten',
      icon: '👀',
    },
    {
      key: 'report',
      title: 'MELDEN',
      description: 'An Verband senden',
      icon: '📤',
    },
  ];

  const handleTabChange = (key: string) => {
    if (activeTab === 'report' || key === 'report') return;
    if (key !== 'capture' && activePlayers.length === 0) {
      openDialog(
        <div className="text-md">
          Sie müssen aus der Liste der Spieler einige auswählen oder die Liste
          der Turnierspieler durch manuelle Eingabe der Spieler auffüllen. 🏌️‍♂️⛳️
        </div>,
        () => {
          closeDialog();
        },
      );
      return;
    }
    setActiveTab(key);
  };

  useEffect(() => {
    if (
      !['capture', 'report'].includes(activeTab) &&
      activePlayers.length === 0
    ) {
      setActiveTab('capture');
    }
  }, [activePlayers, activeTab, setActiveTab]);

  const isFirstTabRender = React.useRef(true);
  useEffect(() => {
    if (isFirstTabRender.current) {
      isFirstTabRender.current = false;
      return;
    }
    axiosInstance.get('/maintenance/status').catch(() => {});
  }, [activeTab]);

  return (
    <div>
      <div className={`px-5 grid gap-8 pb-20`}>
        <ProgressBars
          items={items}
          activeItemKey={activeTab}
          onItemClick={handleTabChange}
        />

        {activeTab === 'capture' && <TournamentCaptureTab />}
        {activeTab === 'set' && <TournamentSetTab />}
        {activeTab === 'preview' && <TournamentPreviewTab />}
        {activeTab === 'report' && <TournamentReportTab />}
      </div>

      {activeTab !== 'report' && (
        <div className="border-t w-full lg:w-auto right-0 lg:left-[288px] z-30 bg-white bottom-0">
          <div className="flex lg:mx-auto lg:max-w-7xl  p-5 items-center justify-between">
            <Button
              className="px-6 flex items-center gap-5"
              onClick={prevTab}
              disabled={!isPrevEnabled() || isLoading}
            >
              <ChevronLeftIcon /> Zurück
            </Button>

            <Button
              className="px-6 flex items-center gap-5"
              onClick={handleNextTab}
              disabled={!isNextEnabled() || isLoading}
            >
              {isLoading ? 'Laden ...' : 'Weiter'} <ChevronRightIcon />
            </Button>
          </div>
        </div>
      )}
    </div>
  );
};

export default TournamentPage;
